import React from 'react';
import Lir from '../../../../../components/Forms/lir/index';

function TIFLIR() {
  return <Lir module="tif" />
};

export default TIFLIR;
